import { ToggleSwitch } from '@tableau/tableau-ui';
import * as React from 'react';
import { makeTestId } from '../../utils/Declarative';
import { EventUtilsOptOut, PropsAndInputAttrs } from '../../utils/ReactHelpers';

export interface ToggleSwitchProps {
  /** NOTE: applied to the root element, not the `<input>`. */
  className?: string;
  /** NOTE: applied to the root element, not the `<input>`. */
  style?: React.CSSProperties;
  /** Suffixed with `'-ToggleSwitch'` */
  testId?: string;
  /**
   * Whether the label text will align on the left side of the container, or the right side (adjacent to the switch).
   * In either case, when width-constrained, the label text automatically moves above the switch.
   * @default "left"
   */
  textAlign?: 'left' | 'right';
}

export const ToggleSwitchWidget = React.forwardRef<HTMLInputElement, PropsAndInputAttrs<ToggleSwitchProps>>(({ testId, ...props }, ref) =>
  <ToggleSwitch {...props} {...EventUtilsOptOut} data-tb-test-id={makeTestId(testId, 'ToggleSwitch')} ref={ref} />
);
ToggleSwitchWidget.displayName = 'ToggleSwitchWidget';
ToggleSwitchWidget.defaultProps = { textAlign: 'left' };
